<template>
  <div class="plan-card" :class="{ 'is-recommended': plan.recommended }" :data-test="`plan-card-${plan.id}`">
    <div v-if="plan.recommended" class="plan-card__pill">MOST POPULAR</div>
    <div class="plan-card__title">{{ plan.title }}</div>
    <div class="plan-card__tag">{{ plan.tag }}</div>
    <div class="plan-card__price">
      <span class="plan-card__amount">{{ formatPrice(perMonth) }}</span>
      <span class="plan-card__unit">/ month</span>
    </div>
    <div v-if="yearly && plan.prices.year" class="plan-card__note">
      <b>{{ formatPrice(plan.prices.year) }} paid annually.</b>
      <span class="plan-card__save">You save {{ formatPrice(saving) }}</span>
    </div>
    <div v-else-if="yearly" class="plan-card__note plan-card__note--muted">Billed monthly</div>
    <div class="plan-card__refund">7 day refund guarantee</div>
    <div v-if="plan.creditLine" class="plan-card__credit-line">{{ plan.creditLine }}</div>
    <button type="button" class="pop-auth__btn plan-card__cta" :disabled="busy" @click="$emit('choose', plan)">
      Choose {{ plan.title }}
    </button>
    <ul class="plan-card__bullets">
      <li v-for="bullet in plan.bullets" :key="bullet">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" :stroke="plan.recommended ? '#FFCC00' : '#25A97A'" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
        <span>{{ bullet }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { formatPrice, perMonth, yearlySaving } from './plans'

export default {
  name: 'PlanCard',
  props: {
    plan: { type: Object, required: true },
    yearly: { type: Boolean, default: true },
    busy: { type: Boolean, default: false },
  },
  computed: {
    perMonth() {
      return perMonth(this.plan, this.yearly ? 'year' : 'month')
    },
    saving() {
      return yearlySaving(this.plan)
    },
  },
  methods: { formatPrice },
}
</script>

<style scoped lang="scss">
@import './auth-tokens.scss';

.plan-card {
  position: relative;
  background: #fff;
  color: $pop-teal;
  border: 1px solid #e3eaeb;
  border-radius: 18px;
  padding: 26px;
  box-shadow: 0 10px 30px -18px rgba(1, 71, 81, 0.18);
  transition: transform 0.2s cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 0.2s;

  &:hover { transform: translateY(-4px); box-shadow: 0 26px 50px -22px rgba(1, 71, 81, 0.32); }

  &.is-recommended { background: $pop-teal; color: #fff; border-color: $pop-teal; }

  &__pill {
    position: absolute; top: 18px; right: 18px;
    background: #ffcc00; color: $pop-teal;
    font-size: 11px; font-weight: 800; letter-spacing: 0.04em;
    padding: 5px 10px; border-radius: 999px;
  }
  &__title { font-family: 'Mulish', sans-serif; font-weight: 800; font-size: 20px; }
  &__tag { font-size: 13px; opacity: 0.7; margin-bottom: 16px; }
  &__price { display: flex; align-items: baseline; gap: 4px; }
  &__amount { font-family: 'Mulish', sans-serif; font-weight: 800; font-size: 40px; letter-spacing: -0.02em; }
  &__unit { opacity: 0.7; font-size: 13px; }
  &__note { font-size: 12.5px; margin-top: 4px; }
  &__note--muted { opacity: 0.7; }
  &__save { color: $pop-success; font-weight: 700; margin-left: 4px; }
  .is-recommended &__save { color: #ffcc00; }
  &__refund { font-size: 12.5px; font-weight: 700; margin-top: 4px; }
  &__credit-line { font-size: 12.5px; opacity: 0.8; margin: 6px 0 10px; line-height: 1.4; }
  &__cta {
    width: 100%; margin: 16px 0 20px; font-size: 14.5px; padding: 13px 16px;
    background: $pop-teal; color: #fff; box-shadow: none;
  }
  .is-recommended &__cta { background: $pop-accent; box-shadow: $auth-primary-shadow; }
  &__bullets {
    list-style: none; padding: 0; margin: 0; display: grid; gap: 9px;
    li { display: flex; gap: 9px; font-size: 13px; line-height: 1.4; }
    svg { flex: none; margin-top: 2px; }
  }
}
</style>
